module.exports = __webpack_public_path__ + "static/media/radar.9fb63913.svg";